import { __assign, __makeTemplateObject, __rest } from "tslib";
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import styled, { withTheme } from 'styled-components';
import { Button } from '../../components/Button';
import { Flex } from '../../components/Flex';
import { getColor, opaque, px } from '../../utils';
var ICON_SIZE = 14;
var Wrapper = styled(Flex)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: relative;\n\tmargin: 0;\n\tpadding: ", ";\n\tpadding-right: ", ";\n\tbox-shadow: 0 0 10px 0\n\t\t", ";\n\tborder-radius: 10px;\n\tborder: 1px solid\n\t\t", ";\n\tbackground-color: ", ";\n\tcolor: ", ";\n"], ["\n\tposition: relative;\n\tmargin: 0;\n\tpadding: ", ";\n\tpadding-right: ",
    ";\n\tbox-shadow: 0 0 10px 0\n\t\t", ";\n\tborder-radius: 10px;\n\tborder: 1px solid\n\t\t",
    ";\n\tbackground-color: ",
    ";\n\tcolor: ",
    ";\n"])), function (props) { return px(props.theme.space[3]); }, function (props) {
    return px(props.hasDismissButton ? props.theme.space[4] : props.theme.space[3]);
}, function (props) { return opaque(props.theme.colors.quartenary.main, 0.15); }, function (props) {
    return props.bordered
        ? props.solid
            ? getColor(props, 'bg', 'main')
            : props.theme.colors.quartenary.main
        : 'transparent';
}, function (props) {
    return props.solid ? getColor(props, 'bg', 'light') : 'white';
}, function (props) {
    return props.solid ? getColor(props, 'bg', 'dark') : props.color || 'inherit';
});
var DismissButton = styled(Button)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tposition: absolute;\n\t& svg {\n\t\theight: ", ";\n\t\twidth: ", ";\n\t}\n\tfont-size: ", ";\n\tpadding: ", "; /* give more clickable surface area */\n\ttop: ", ";\n\tright: ", ";\n\ttransform: translate(0, -50%);\n"], ["\n\tposition: absolute;\n\t& svg {\n\t\theight: ", ";\n\t\twidth: ", ";\n\t}\n\tfont-size: ", ";\n\tpadding: ",
    "; /* give more clickable surface area */\n\ttop: ", ";\n\tright: ", ";\n\ttransform: translate(0, -50%);\n"])), px(ICON_SIZE), px(ICON_SIZE), px(ICON_SIZE), function (props) {
    return px(props.theme.space[2]);
}, function (props) { return px(props.theme.space[3] + props.baselineHeight / 2); }, function (props) { return px(props.theme.space[3] - props.theme.space[2]); });
export var DismissableContainer = withTheme(React.forwardRef(function (_a, ref) {
    var children = _a.children, onDismiss = _a.onDismiss, baselineHeight = _a.baselineHeight, solid = _a.solid, theme = _a.theme, a11yTitle = _a.a11yTitle, bordered = _a.bordered, restProps = __rest(_a, ["children", "onDismiss", "baselineHeight", "solid", "theme", "a11yTitle", "bordered"]);
    var baseline = baselineHeight || theme.fontSizes[2] * theme.lineHeight;
    return (React.createElement(Wrapper, __assign({ solid: solid, bordered: bordered, hasDismissButton: Boolean(onDismiss), ref: ref }, restProps),
        children,
        onDismiss && (React.createElement(DismissButton, { title: a11yTitle || 'Dismiss', a11yTitle: a11yTitle || 'Dismiss', baselineHeight: baseline, color: solid
                ? getColor(__assign({ theme: theme }, restProps), 'bg', 'dark')
                : undefined, primary: !solid, plain: true, onClick: onDismiss },
            React.createElement(FontAwesomeIcon, { icon: faTimes })))));
}));
DismissableContainer.defaultProps = {
    bordered: true,
};
var templateObject_1, templateObject_2;
